import { useContext, useEffect, useState } from 'react';
import {
  MessageTypeButton,
  MessageTypeSelectContainer,
} from './template_config.styles';
import { categoriesList } from '../../enums/templateForm.enums';
import { TemplateCategoryOption } from '../../types/jbForm.types';
import { TemplateContext } from '../../contexts/templates.context';

const MessageTypeSelect = ({
  onCategoryChange,
}: {
  onCategoryChange: (category: TemplateCategoryOption) => void;
}) => {
  const { selectedTemplateCategory } = useContext(TemplateContext);
  const categoriesAvailable = categoriesList;
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    console.log({ selectedTemplateCategory, categoriesList });
    if (selectedTemplateCategory) {
      const categoryIndex = categoriesList.findIndex(
        (category) => category.value === selectedTemplateCategory.value,
      );
      setSelected(categoryIndex);
    }
  }, [selectedTemplateCategory]);

  const buttonClicked = function (index: number) {
    if (selected === index) {
      return;
    }
    setSelected(index);
    onCategoryChange(categoriesList[index]);
  };

  return (
    selectedTemplateCategory &&
    categoriesAvailable && (
      <MessageTypeSelectContainer>
        {categoriesAvailable.map((category, index) => {
          return (
            <MessageTypeButton
              key={`categoriesAvailable-${index}-${category.value}`}
              $selected={selected === index}
              onClick={() => buttonClicked(index)}
              className={
                categoriesAvailable.length === 3 && index === 1
                  ? 'isMiddle'
                  : ''
              }
            >
              {category.label}
            </MessageTypeButton>
          );
        })}
      </MessageTypeSelectContainer>
    )
  );
};
export default MessageTypeSelect;
